
import SincronizacaoService from "@/services/SincronizacaoService";

export default {
  name: "PdvSincronizacaoInicial",

  data() {
    return {
      progresso: 0,
      statusSync: "Iniciando...",
      erro: null,
      concluido: false,
    };
  },

  async mounted() {
    if (!this.$isDesktop) {
      this.$router.push({ name: "pdvDesktopLogin" });
      return;
    }
    await this.iniciarSync();
  },

  methods: {
    async iniciarSync() {
      this.erro = null;
      this.concluido = false;
      this.progresso = 0;
      this.statusSync = "Iniciando...";

      try {
        const apiUrl = await this.$electron.config.get("api_url");
        const token = await this.$electron.config.get("api_token");

        if (!apiUrl || !token) {
          this.erro = "Configuração da API não encontrada. Faça login novamente.";
          return;
        }

        await SincronizacaoService.sincronizarInicial({
          apiUrl,
          token,
          onProgress: (pct, msg) => {
            this.progresso = pct;
            this.statusSync = msg;
          },
        });

        this.progresso = 100;
        this.statusSync = "Sincronização concluída!";
        this.concluido = true;

        setTimeout(() => {
          this.$router.push({ name: "pdvDesktopDashboard" });
        }, 1500);
      } catch (e) {
        this.erro = `Erro na sincronização: ${e.message}`;
      }
    },
  },
};
